export class SapObjectSampleRowsInnerInner {
    static discriminator = undefined;
    static attributeTypeMap = [];
    static getAttributeTypeMap() {
        return SapObjectSampleRowsInnerInner.attributeTypeMap;
    }
    constructor() {
    }
}
